<script setup lang="ts">
import Skeleton from '@/shared/ui/Skeleton/index';
</script>

<template>
  <Skeleton width="100%" height="50px" />
</template>
